import React from 'react';

import { Box, BoxProps } from '@mantine/core';

import { DragDropContext, Droppable } from '../../../DragAndDrop';

type DroppableWrapperProps = {
  children: React.ReactNode;
  handleUpdateOrder: (sourceIndex: number, destinationIndex: number) => void;
  boxProps?: BoxProps;
  droppableId?: string;
};

const DroppableWrapper = ({
  boxProps,
  children,
  handleUpdateOrder,
  droppableId,
}: DroppableWrapperProps) => {
  return (
    <DragDropContext
      onDragEnd={({ destination, source }) =>
        handleUpdateOrder(source.index, destination?.index ?? 0)
      }
    >
      <Droppable droppableId={`${droppableId}-list`} direction="vertical">
        {(provided) => (
          <Box {...boxProps} {...provided.droppableProps} ref={provided.innerRef}>
            {children}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export { DroppableWrapper };
